import { render, staticRenderFns } from "./AudioBox.vue?vue&type=template&id=779125eb&"
import script from "./AudioBox.vue?vue&type=script&lang=js&"
export * from "./AudioBox.vue?vue&type=script&lang=js&"
import style0 from "./AudioBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports